import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '42px',
    padding: '12px 40px 10px',
    ['@media (max-width:600px)']: {
      padding: '12px 15px 10px',
      flexDirection: 'column-reverse',
      alignItems: 'normal',
      height: '80px'
    }
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    ['@media (max-width:600px)']: {
      flexDirection: 'row-reverse',
      justifyContent: 'space-between'
    }
  },
  logo: {
    height: '38px',
    marginRight: '15px',
    ['@media (max-width:600px)']: {
      margin: 0
    }
  },
  actions: {
    display: 'flex',
    // alignItems: 'baseline',
    minWidth: '62px',
    ['@media (max-width:600px)']: {
      justifyContent: 'space-between',
      margin: '0 -5px 0 -10px'
    }
  },
  dropdowns: {
    display: 'flex'
  },
  button: {
    marginLeft: '10px',
    color: '#59758B'
  },
  cancelIcon: {
    fontSize: '18px'
  },
  selectRoot: {
    color: '#59758B'
  },
  currencySelectRoot: {
    color: '#59758B'
  },
  cancel: {
    color: '#59758B',
    marginTop: '2px'
  },
  selectIcon: {
    color: '#59758B'
  },
  dropdownInputBase: {
    border: 0,
    '&:hover': {
      border: 0
    }
  },
  language: {
    marginRight: '10px'
  }
});

export default useStyles;
